import { useState } from 'react'

import { useAppStore } from '@/store/useAppStore'
import { useAutobot } from './useAutobot'
import { ControlPanel } from './ControlPanel'
import { ActiveTradesTable } from './ActiveTradesTable'
import { TradeStatsBlock } from './TradeStatsBlock'
import { StatsPanel } from './StatsPanel'
import { BotSettings } from './BotSettings'
import { ApiConnections } from './ApiConnections'
import { LogHistoryTabs } from './LogHistoryTabs'
import { Modal } from '@/components/common/Modal'
import { Spinner } from '@/components/common/Spinner'
import { InfoIcon, SettingsIcon } from '@/components/common/icons'

/** Страница «Авто-бот» (Этап 17): управление dry-run, настройки, статистика, сделки, журнал. */
export function AutoBotPage() {
  const { engine, pending, error, run } = useAutobot()
  const exchanges = useAppStore((s) => s.exchanges)
  const eventStamp = useAppStore((s) => s.eventStamp)
  const [settingsOpen, setSettingsOpen] = useState(false)

  if (!engine) {
    return (
      <>
        <div className="page-head">
          <div>
            <h1 className="page-head__title">Авто-бот</h1>
            <p className="page-head__sub">Управление, настройки, статистика и журнал сделок</p>
          </div>
        </div>
        <div className="panel">
          <div className="empty">
            <Spinner size={26} />
            <div className="empty__text">Загрузка состояния движка…</div>
          </div>
        </div>
      </>
    )
  }

  const live = engine.mode === 'live'

  return (
    <>
      <div className="autobot-stack">
      <div className="page-head">
        <div>
          <h1 className="page-head__title">Авто-бот</h1>
          <p className="page-head__sub">Управление dry-run, настройки, статистика и журнал сделок</p>
        </div>
        <div className="page-head__actions">
          <button
            type="button"
            className="btn btn--sm"
            onClick={() => setSettingsOpen(true)}
            aria-haspopup="dialog"
          >
            <SettingsIcon size={15} />
            Настройки
          </button>
          <span className={`mode-pill ${live ? 'mode-pill--live' : 'mode-pill--dry'}`}>
            <InfoIcon size={14} />
            {live ? 'Боевой режим (LIVE)' : 'Симуляция (DRY-RUN)'}
          </span>
        </div>
      </div>

      {error ? <div className="note note--warn autobot-error">{error}</div> : null}

      <ControlPanel engine={engine} run={run} pending={pending} />

      <TradeStatsBlock engine={engine} />

      <div className="panel autobot-trades">
        <div className="panel__head">
          <div>
            <div className="panel__title">Активные сделки</div>
            <div className="panel__subtitle">
              Открытые связки · «Текущий PNL» из единого PnL-источника (комиссии + фандинг +
              разница цен)
            </div>
          </div>
          <span className="badge badge--accent">{engine.active_trades.length}</span>
        </div>
        <ActiveTradesTable trades={engine.active_trades} />
      </div>

      <StatsPanel engine={engine} />

      <LogHistoryTabs run={run} pending={pending} eventStamp={eventStamp} />
      </div>

      <Modal
        open={settingsOpen}
        title="Настройки"
        subtitle="Параметры бота (§1.11) и подключения бирж"
        wide
        onClose={() => setSettingsOpen(false)}
      >
        <BotSettings engine={engine} run={run} pending={pending} />
        <ApiConnections engine={engine} exchanges={exchanges} run={run} pending={pending} />
      </Modal>
    </>
  )
}
